module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cardHeader1":"Email links to Online Services","cardHeader2":"Forms: Marriage Application, Notary and CPL","link1":"Email link","alter":"OR","categoryTitle":"CATEGORIES"},"es":{"cardHeader1":"Servicios en Línea","cardHeader2":"Formas: Marriage Application, Notary and CPL","link1":"Email link","alter":"O","categoryTitle":"Categorías"}}')
  delete Component.options._Ctor
}
